import { type LabelProps } from '@direct-frontend/components';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { STATUS_ICON_MAP } from './constants';
import { PRODUCT_VARIANT_STATUS_MAP } from './constants';

export function getProductVariantStatusLabelProps(
    status: OpenApiSchemaProductVariant['status']
): Pick<LabelProps, 'addonLeft' | 'children'> {
    return { addonLeft: STATUS_ICON_MAP[status], children: PRODUCT_VARIANT_STATUS_MAP[status] ?? status };
}
